var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDeleteFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_delete_",
    "data-name": "icn_delete ",
    transform: "translate(-604 -210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8216",
    "data-name": "Group 8216",
    transform: "translate(611.502 216.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_1_",
    "data-name": "delete (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M222.723,154.7a.325.325,0,0,0-.325.325v6.142a.325.325,0,0,0,.65,0v-6.142A.325.325,0,0,0,222.723,154.7Zm0,0",
    transform: "translate(-215.17 -149.675)",
    fill: "#5c6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M104.723,154.7a.325.325,0,0,0-.325.325v6.142a.325.325,0,1,0,.65,0v-6.142A.325.325,0,0,0,104.723,154.7Zm0,0",
    transform: "translate(-101.005 -149.675)",
    fill: "#5c6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M.92,4.13v8.007A1.793,1.793,0,0,0,1.4,13.373a1.6,1.6,0,0,0,1.161.5H8.706a1.6,1.6,0,0,0,1.161-.5,1.793,1.793,0,0,0,.477-1.237V4.13a1.241,1.241,0,0,0-.319-2.441H8.362V1.282A1.277,1.277,0,0,0,7.075,0H4.189A1.277,1.277,0,0,0,2.9,1.282v.406H1.238A1.241,1.241,0,0,0,.92,4.13Zm7.787,9.1H2.558a1.029,1.029,0,0,1-.988-1.089V4.158H9.694v7.978a1.029,1.029,0,0,1-.988,1.089ZM3.552,1.282A.626.626,0,0,1,4.189.649H7.075a.626.626,0,0,1,.637.634v.406H3.552ZM1.238,2.338h8.787a.585.585,0,1,1,0,1.17H1.238a.585.585,0,0,1,0-1.17Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#5c6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M163.723,154.7a.325.325,0,0,0-.325.325v6.142a.325.325,0,1,0,.65,0v-6.142A.325.325,0,0,0,163.723,154.7Zm0,0",
    transform: "translate(-158.088 -149.675)",
    fill: "#5c6873"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3967",
    "data-name": "Rectangle 3967",
    width: 27,
    height: 27,
    transform: "translate(604 210)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDeleteFilter);
export default __webpack_public_path__ + "static/media/icn_delete_filter.84004dd10b6aa5cf1776264be030c688.svg";
export { ForwardRef as ReactComponent };